var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCronos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 120.1 138.8",
    viewBox: "0 0 120.1 138.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002d74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002d74",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 0 139.8898)",
    gradientUnits: "userSpaceOnUse",
    x1: 90.1166,
    x2: 90.1166,
    xlinkHref: "#a",
    y1: 1.0868,
    y2: 70.4884
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 139.8898)",
    gradientUnits: "userSpaceOnUse",
    x1: 30.0233,
    x2: 30.0233,
    xlinkHref: "#a",
    y1: 139.8898,
    y2: 70.4884
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60.1 0-60.1 34.7v69.4l60.1 34.7 60-34.7v-69.4zm42.2 93.8-42.3 24.4-42.2-24.4v-48.8l42.3-24.4 42.2 24.4z",
    fill: "#002d74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.1 138.8 60-34.7v-69.4l-60-34.7v20.6l42.2 24.4v48.9l-42.3 24.4v20.5z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60 0-60 34.7v69.4l60 34.7v-20.6l-42.2-24.4v-48.9l42.2-24.3z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m88.1 85.6-28 16.2-28.1-16.2v-32.4l28.1-16.2 28 16.2-11.7 6.8-16.4-9.5-16.3 9.5v18.9l16.4 9.5 16.4-9.5z",
    fill: "#002d74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCronos);
export default __webpack_public_path__ + "static/media/cronos.3076a0abf6c9ad5df93458e2c08b0927.svg";
export { ForwardRef as ReactComponent };